

































import {
  computed,
  defineComponent,
  onMounted,
  onUnmounted,
  ref,
  useStore,
} from '@nuxtjs/composition-api'

import BlockTopMessage from '@/components/BlockTopMessage.vue'
import { useGetYmClientId } from '@/composition/useGetYmClientId'

export default defineComponent({
  name: 'BlockMainPageSurvey',
  components: {
    BlockTopMessage,
  },
  props: {
    icon: {
      type: String,
      default: 'icon/confetti',
    },
    text: {
      type: String,
      default: '',
    },
    buttonText: {
      type: String,
      default: '',
    },
    textColor: {
      type: String,
      default: '',
    },
    iconColor: {
      type: String,
      default: '',
    },
    background: {
      type: String,
      default: '',
    },
  },
  setup() {
    const isActive = ref(false)
    const isVisible = ref(true)

    const store = useStore()
    const params = computed(() => store.getters['settings/getMainSurvey'])

    let checkStorageCallback = null

    const { getYmClientId } = useGetYmClientId()

    const onClick = async () => {
      const ymClientId = await getYmClientId()
      const testografParams = {
        link: window.location.href,
      }
      if (ymClientId) {
        testografParams.ym_client_id = ymClientId
      }
      window.testograf = {
        params: testografParams,
      }
      const button = document.getElementById('tte-p-tr--685566')
      button?.click()
    }

    onMounted(() => {
      const storageKey = localStorage.getItem('TTGRAF__cancel_reopen-685566')
      isActive.value = storageKey !== 'true'
      if (isActive.value) {
        checkStorageCallback = setInterval(() => {
          const storageKey = localStorage.getItem(
            'TTGRAF__cancel_reopen-685566'
          )
          if (storageKey === 'true') {
            isVisible.value = false
          }
        }, 300)
      }
    })

    onUnmounted(() => {
      clearInterval(checkStorageCallback)

      const testografElement = document.getElementById('ttp-685566')
      testografElement?.remove()
    })

    const onClose = () => {
      isVisible.value = false
    }

    const callTestograf = () => {
      window.ttgrafSetPopupParams?.({ id: 685566 })
    }

    return {
      isActive,
      isVisible,
      onClick,
      onClose,
      params,
      callTestograf,
    }
  },
})
